import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import { PagedResponse, StandardParams } from '../types/interfaces';
import { QBOpenBalanceDiscrepancy, QBSyncHistory, QBCustomerInformation } from '../types/interfaces/quickbooks.interface';
import { QUICKBOOKS_OPEN_BALANCE_DISCREPANCIES, QUICKBOOKS_SYNC, QUICKBOOKS_CUSTOMERINFO } from '../constants/apiEndpoints';

export const getQuickBooksOpenBalanceDiscrepancies = (
  params?: StandardParams,
): Promise<AxiosResponse<QBOpenBalanceDiscrepancy[] | PagedResponse<QBOpenBalanceDiscrepancy>, any>> => {
  return appContextGet(QUICKBOOKS_OPEN_BALANCE_DISCREPANCIES.GET, params);
};

export const syncQuickBooksByAccountId = (accountId: number): Promise<AxiosResponse<any, any>> => {
  return appContextPost(QUICKBOOKS_SYNC.RESYNC, undefined, { accountId: accountId });
};

export const updateQuickBooksSyncHistory = (payload: QBSyncHistory): Promise<AxiosResponse<any, any>> => {
  return appContextPost(QUICKBOOKS_SYNC.SYNC_HISTORY, payload);
};

export const getQuickBooksCustomerInfo = (accountId: number): Promise<AxiosResponse<QBCustomerInformation, any>> => {
  return appContextGet(QUICKBOOKS_CUSTOMERINFO.GET_ + accountId);
};

export const getQuickBooksCustomerByRefNumber = (quickBooksCustomerRef: string): Promise<AxiosResponse<QBCustomerInformation, any>> => {
  return appContextGet(QUICKBOOKS_CUSTOMERINFO.GET_BY_REF_ + quickBooksCustomerRef);
};
